// Navegación móvil compartida y acceso al registro de la camada activa.

import { Home, Layers, MoreHorizontal, Package, Plus } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { RegistrationMenu } from './RegistrationMenu';

const ITEMS = [
  { to: '/', key: 'navigation.home', icon: Home, end: true },
  { to: '/camadas', key: 'navigation.camadas', icon: Layers, end: false },
  { to: '/pienso', key: 'navigation.pienso', icon: Package, end: false },
  { to: '/mas', key: 'navigation.more', icon: MoreHorizontal, end: false },
] as const;

export function BottomNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const [registerOpen, setRegisterOpen] = useState(false);
  const moreActive = /^\/(mas|ajustes|liquidacion|demo)(\/|$)/.test(location.pathname);

  function item(index: number) {
    const { to, key, icon: Icon, end } = ITEMS[index];
    const content = (
      <>
        <Icon size={24} aria-hidden strokeWidth={1.8} />
        <span>{t(key)}</span>
      </>
    );
    return (
      <li key={to}>
        {to === '/mas' ? (
          <Link
            to={to}
            data-testid="nav-mas"
            aria-current={moreActive ? 'page' : undefined}
            className={`ui-nav-item ${moreActive ? 'is-active' : ''}`}
          >
            {content}
          </Link>
        ) : (
          <NavLink
            to={to}
            end={end}
            data-testid={`nav-${to === '/' ? 'inicio' : to.slice(1)}`}
            className={({ isActive }) => `ui-nav-item ${isActive ? 'is-active' : ''}`}
          >
            {content}
          </NavLink>
        )}
      </li>
    );
  }

  return (
    <>
      <nav aria-label="Navegación principal" data-testid="bottom-nav" className="ui-bottom-nav">
        <ul>
          {item(0)}
          {item(1)}
          <li>
            <button
              type="button"
              aria-label="Registrar"
              aria-haspopup="dialog"
              aria-expanded={registerOpen}
              onClick={() => setRegisterOpen(true)}
              className="ui-nav-item ui-nav-register"
            >
              <span className="ui-nav-plus">
                <Plus size={28} strokeWidth={1.8} aria-hidden />
              </span>
              <span>{t('navigation.register')}</span>
            </button>
          </li>
          {item(2)}
          {item(3)}
        </ul>
      </nav>
      {registerOpen && <RegistrationMenu onClose={() => setRegisterOpen(false)} />}
    </>
  );
}
